.header {
	height: 8%;
	flex-wrap: wrap;
	align-items: center;
	border-bottom: 0.5px solid #dee2e6;

	.optionButton {
		display: inline-flex;
		border: 1px solid transparent;
		border-color: #0000002e;
		background-color: #fafafa;
		padding: 6px 11px;
		border-radius: 3px;
		font-size: 16px;
		margin-right: 10px;
		font-weight: 400;
		color: black;
		cursor: pointer;

		span {
			margin-left: 27px;
		}

		&:hover {
			background-color: #7fb02f;
			border-color: #7fb02f;
			color: white;
		}

		.icon {
			margin-right: 7px;
			margin-top: 3px;
		}

		&.newInventory {
			background-image: url("../../../../../assets/images/desktop/cargarnegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;

			&:hover {
				background-image: url("../../../../../assets/images/desktop/cargarblanco.svg");
			}

			&.active {
				background-image: url("../../../../../assets/images/desktop/cargarblanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		&.exportInventory {
			background-image: url("../../../../../assets/images/desktop/descargarnegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;

			&:hover {
				background-image: url("../../../../../assets/images/desktop/descargarblanco.svg");
			}

			&.active {
				background-image: url("../../../../../assets/images/desktop/descargarblanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}
	}

	.separator {
		width: 98%;
		margin-top: 0.5em;
		margin-bottom: 0.5em;
	}
}

.actionsDropdown {
	/* min-width: 15em; */
	/* background-color: white; */
	/* border-radius: 5px;
	box-shadow: 5px 5px 10px #dfe1e6; */

	.actionH4 {
		font-size: 16px;
		margin-top: 5px;
		margin-left: 5px;
		color: #628822;
	}

	.actionDivider {
		margin-top: 5px;
		margin-bottom: 5px;
	}

	@media (max-width: 400px) {
		min-width: 15em;
	}

	.actionsMenu {
		width: 15em;
		background-color: white;
		border-radius: 5px;
		box-shadow: 5px 5px 10px #dfe1e6;
		min-height: initial;
		margin-bottom: 5px;
		text-align: left;
		font-size: 14px;
		border-top: 0.5px solid #628822;

		.actionItem {
			border: 0px;
			background-color: white;
			padding: 5px;

			&:hover {
				background-color: #7fb02f;
			}
		}

		.icon {
			width: 1em;
			max-width: 1em;
		}

		.tdSpan {
			padding-left: 33px;
		}

		.tdAssign {
			background-image: url("../../../../../assets/images/desktop/asignar.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdGenerate {
			background-image: url("../../../../../assets/images/desktop/qrcode.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdConfirm {
			background-image: url("../../../../../assets/images/desktop/confirm.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdDelivery {
			background-image: url("../../../../../assets/images/desktop/checklist.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdShow {
			background-image: url("../../../../../assets/images/desktop/show.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdFinish {
			background-image: url("../../../../../assets/images/desktop/check-line.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdReturn {
			background-image: url("../../../../../assets/images/desktop/return.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdEdit {
			background-image: url("../../../../../assets/images/desktop/editar-1.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdPdf {
			background-image: url("../../../../../assets/images/desktop/pdf.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdCopy {
			background-image: url("../../../../../assets/images/desktop/copy.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdApproved {
			background-image: url("../../../../../assets/images/desktop/aprobar_order.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdRejected {
			background-image: url("../../../../../assets/images/desktop/rechazar_order.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdDelete {
			background-image: url("../../../../../assets/images/desktop/eliminar.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdExcel {
			background-image: url("../../../../../assets/images/desktop/pdf.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdAttach {
			background-image: url("../../../../../assets/images/desktop/folder-move.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		@media (max-width: 400px) {
			font-size: 15px;
		}
	}
}

.dropdown {
	.dropdownToggle {
		background-color: #fafafa !important;
		color: #333 !important;
		padding: 7px 10px !important;
		border-radius: 10px !important;
		font-size: 15px !important;
		font-weight: 500 !important;
		margin-right: 10px !important;
		cursor: pointer !important;
		border: none !important;

		&:hover {
			background-color: #7fb02f !important;
			color: white !important;
		}

		&.active {
			background-color: #7fb02f !important;
			color: white !important;
		}
	}

	.dropdownToggleWithIcon {
		background-color: #fafafa !important;
		color: #333 !important;
		padding: 7px 10px !important;
		border-radius: 10px !important;
		font-size: 15px !important;
		font-weight: 500 !important;
		margin-right: 10px !important;
		cursor: pointer !important;
		border: none !important;
		width: 120px !important;
		display: inline-flex !important;
		align-items: center !important;
		justify-content: space-between !important;
		gap: 5px !important;

		&:hover {
			background-color: #7fb02f !important;
			color: white !important;
		}

		&.active {
			background-color: #7fb02f !important;
			color: white !important;
		}
	}
}
